import React from 'react';
import ActiveComponent from '../ActiveComponent/ActiveComponent';

const Manager = ({ houseData }) => {
  return <ActiveComponent houseData={houseData} />;
};

export default Manager;
